import {documentLoader, installCopy} from './menu-docs.mjs';
import {setMenuTitle} from './brand-ui.mjs';
// Main menu (the #menu drawer): a list page and sub-pages, up to two levels (legal -> imprint). The drawer itself (open, close, scrim, swipe,
// Escape, focus) is drawer.mjs; this module decides which page shows and wires the back gesture. Opening always starts at the list.
export const MENU_PAGES = {list: 'menuTitle', settings: 'settingsTitle', info: 'infoTitle', connector: 'menuConnector', legal: 'menuLegal',
  imprint: 'imprintTitle', privacy: 'privacyTitle', data: 'dataNoticeTitle'};
export function menuNav() {
  const stack = ['list'];
  return {
    get page() { return stack[stack.length - 1]; },
    get depth() { return stack.length - 1; },
    open(next) { if (!(next in MENU_PAGES) || stack.includes(next)) return false; stack.push(next); return true; },
    back() { if (stack.length < 2) return false; stack.pop(); return true; },
    reset() { stack.length = 1; },
  };
}
export function installMenu({drawer, doc = document, win = globalThis, loadDocument = documentLoader({doc})}) {
  const $ = id => doc.getElementById(id), nav = menuNav(), sheet = $('menu'), body = $('menu-body'), back = $('menu-back'), title = $('menu-title');
  let openers = [], depth = 0, expectPop = false;
  const history = win.history;
  // Browser history: one entry for the open menu and one per sub-page, so the back gesture steps back and then closes.
  const push = () => { depth++; history?.pushState({menuDepth: depth}, ''); };
  const pop = count => { if (!depth || !count) return; depth -= count; expectPop = true; history.go(-count); };
  const refocus = opener => (opener?.disabled ? null : opener)?.focus({preventScroll: true});
  function render(direction) {
    for (const el of body.children) {
      const shown = el.dataset.page === nav.page;
      el.hidden = !shown;
      el.classList.remove('slide-in', 'slide-back');
      if (shown && direction) { void el.offsetWidth; el.classList.add(direction); }
      if (shown && el.dataset.doc) loadDocument(el);
    }
    sheet.dataset.page = nav.page; back.hidden = nav.page === 'list';
    setMenuTitle(title, MENU_PAGES[nav.page]);  // the list shows the wordmark
    body.scrollTop = 0;
  }
  function show(page, opener) {
    if (!nav.open(page)) return;
    openers.push(opener); push(); render('slide-in'); back.focus({preventScroll: true});
  }
  function goBack() {
    if (!nav.back()) return;
    pop(1); render('slide-back'); refocus(openers.pop());
  }
  const isOpen = () => drawer.isOpen;
  // Open from the burger; a closed menu always starts at the list, an open one closes.
  $('menu-button').addEventListener('click', () => { if (!isOpen()) { nav.reset(); openers = []; render(); } drawer.toggle(); });
  back.addEventListener('click', goBack);
  body.addEventListener('click', event => {
    const item = event.target.closest?.('[data-menu-page]');
    if (!item || item.disabled) return;
    show(item.dataset.menuPage, item);
  });
  installCopy(body, {doc});
  // Every way of opening or closing the drawer ends here: sync the history entries.
  doc.addEventListener('drawerchange', event => {
    if (event.detail?.open) { if (!depth) push(); }
    else pop(depth);
  });
  win.addEventListener?.('popstate', event => {
    if (expectPop) { expectPop = false; return; }
    const to = event.state?.menuDepth ?? 0;
    if (to >= depth) return;
    depth = to;
    if (to === 0) { if (isOpen()) drawer.close(); return; }
    let opener = null;
    while (nav.depth > to - 1 && nav.back()) opener = openers.pop();
    render('slide-back'); refocus(opener);
  });
  // Escape steps back one level (sub-page, list, closed): on a sub-page the drawer's own Escape handling is skipped.
  doc.addEventListener('menuescape', event => { if (nav.page !== 'list') { event.preventDefault(); goBack(); } });
  return {nav, render, show, back: goBack,
    // Programmatic entry (for example a future deep link): open the drawer at a page.
    openAt(page) { nav.reset(); openers = []; render(); if (!isOpen()) drawer.open(); if (nav.open(page)) { openers.push(null); push(); render(); } }};
}
